import {
  format as formatDateFNS,
  formatDistance as formatDistanceDateFNS,
  Locale
} from 'date-fns'
import { fr, enUS } from 'date-fns/locale'

/**
 * Format a date using date-fns
 * @param date The date to format (must be in format YYYY MM DD)
 * @param formatType The format pattern
 * @param lang The language ('en' or 'fr')
 * @returns Formatted date string
 */
export const format = (
  date: Date | number | string,
  formatType: string = 'dd-MM-yyyy',
  lang: string = 'en'
): string => {
  /* 
  The Date object has to be in format : YYYY MM DD
  */
  if (new Date(date).toDateString() === 'Invalid Date') {
    return 'Invalid Date'
  }
  const loc: Locale = lang === 'fr' ? fr : enUS
  return formatDateFNS(new Date(date), formatType, { locale: loc })
}

/**
 * Format the distance between two dates
 * @param startDate The start date
 * @param endDate The end date
 * @param lang The language ('en' or 'fr')
 * @returns Formatted distance string
 */
export const formatDistance = (
  startDate: Date | number | string,
  endDate: Date | number | string,
  lang: string = 'en'
): string => {
  const loc: Locale = lang === 'fr' ? fr : enUS
  return formatDistanceDateFNS(new Date(startDate), new Date(endDate), {
    addSuffix: true,
    locale: loc
  })
}
